import { connect } from "react-redux"

import { autocompleteConceptsRequest } from "../../../actions/autocomplete-actions"

import ConceptMappingsEditWidget from "./ConceptMappingsEditWidget"

export default function buildEditMappingsContainer(
    presentationAccessor,
    updateConceptsActionCreator,
    clearConceptsActionCreator,
    addMappingActionCreator,
    removeMappingActionCreator,
    Widget = ConceptMappingsEditWidget
) {
    const mapStateToProps = ({ presentation }, props) => ({
        ...props,
        mappingToBeAdded: presentation[presentationAccessor].mappingToBeAdded,
        mappingToBeDeleted:
            presentation[presentationAccessor].mappingToBeDeleted,
        isFetchingPreview: presentation[presentationAccessor].isFetchingPreview,
        ...presentation[presentationAccessor].mappingPreview,
    })

    const mapDispatchToProps = (dispatch) => ({
        onRemoveMapping: (id) => () => dispatch(removeMappingActionCreator(id)),
        onConceptSearch: (searchTerm, callback) => {
            dispatch(autocompleteConceptsRequest(searchTerm, callback))
        },
        onUpdateConcepts: (isPositive) => (concepts) =>
            dispatch(updateConceptsActionCreator(concepts, isPositive)),
        onAddMapping: (concept) => dispatch(addMappingActionCreator(concept)),
        onClearConcepts: () => dispatch(clearConceptsActionCreator()),
    })

    return connect(mapStateToProps, mapDispatchToProps)(Widget)
}
